import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { EquipmentAutocompleteFilter } from 'src/app/model/autocompleteFilter';
import { InternalEquipment } from 'src/app/model/internalEquipment';
import { InternalEquipmentService } from 'src/app/services/internalEquipment.service';
import { SnackBarService } from 'src/app/services/snackBar.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { CalibrationParticlePattern } from '../../../../model/particleCalibration';
import { EquipmentPerformances } from '../../../../utils/equipmentUtils';

export interface DialogDataParticlesEditPatternsDialogComponent {
  pattern: CalibrationParticlePattern;
  idsRemove: number[];
}

@Component({
  selector: 'app-particles-edit-patterns-dialog',
  templateUrl: './particles-edit-patterns-dialog.component.html',
  standalone: false,
})
export class ParticlesEditPatternsDialogComponent implements OnInit{

  public equipmentAutoComplete: InternalEquipment[];
  private destroy$ = new Subject<void>();
  public equipmentName: string;

  constructor(
    public dialogRef: MatDialogRef<ParticlesEditPatternsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataParticlesEditPatternsDialogComponent,
    private internalEquipmentService: InternalEquipmentService,
    private translate: TranslateService,
    public dialog: MatDialog,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    if (this.data.pattern.id && this.data.pattern.idEquipment) {
      this.internalEquipmentService.findOne(this.data.pattern.idEquipment).pipe(takeUntil(this.destroy$)).subscribe(item => {
        if (item) {
          this.data.pattern.equipment = item;
        } else {
          this.data.pattern.equipment = new InternalEquipment();
        }
      });
    }
   
  }

  lookupEquipment($event): void {
    let results = this.equipmentAutoComplete;

    const filter = new EquipmentAutocompleteFilter();

    filter.query = $event.target.value;
    filter.pageIndex = 0;
    filter.pageSize = 10;
    filter.sortBy = 'name';
    filter.sortDirection = 'asc';
    filter.forParticlesPattern = true;
    
    this.internalEquipmentService.findAutocomplete(filter).pipe(takeUntil(this.destroy$)).subscribe(item => {
      results = item.content;
      this.equipmentAutoComplete = results?.filter(r => !this.data.idsRemove?.includes(r.id));
    }, () => {
      results = [];
      this.equipmentAutoComplete = results;
    });
  }

  onEquipmentChange($event: any) {
    const equipmentSelected = $event.option.value as InternalEquipment;

    const eqCalibrates = equipmentSelected.performances?.find(ep => ep.idActionType === EquipmentPerformances.CALIBRATION);
    
    if (eqCalibrates) {
      this.data.pattern.equipment = equipmentSelected;
      this.equipmentName = this.data.pattern.equipment?.name;
      this.data.pattern.idEquipment = equipmentSelected.id;
    } else {
      this.data.pattern.equipment = new InternalEquipment();
      this.data.pattern.idEquipment = null;
      this.data.pattern.idEquipment = null;
    }
    
  }

  onOkClick(): void {
    const errs = [];

    if (this.data.pattern.idEquipment == null) {
      errs.push(this.translate.instant('particlesPattern.dialog.equipment.name.label'));
    }

    if (errs.length === 0) {
      this.dialogRef.close(this.data.pattern);
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
